import { useMutation, type UseMutationOptions } from '@tanstack/react-query'
import { pipelineService } from '../services/pipeline/pipeline.service'
import type { CreateDataFlowScheduleRequest } from '../services/pipeline/pipeline.types'

export type CreateDataFlowScheduleVariables = {
  dataFlowId: number
  payload: CreateDataFlowScheduleRequest
}

export function useCreateDataFlowScheduleMutation(
  options?: UseMutationOptions<unknown, Error, CreateDataFlowScheduleVariables>
) {
  return useMutation<unknown, Error, CreateDataFlowScheduleVariables>({
    mutationFn: ({ dataFlowId, payload }) =>
      pipelineService.createDataFlowSchedule(dataFlowId, payload),
    ...options,
  })
}
